import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import theme from "../../../styles/theme";
import "@fontsource/almarai";

import TabsNavHorizontal from "../../reusable/Tab/TabsNavHorizontalCorelia";
import DropdownMenuList from "../../reusable/Dropdown/DropdownMenuList";

const Navbar = ({ logo, toolbar = null }) => {
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState(0);

  const handleLogout = () => {
    localStorage.removeItem("corelia_token");
    localStorage.removeItem("corelia_user");
    navigate("/login");
  };

  const navbarTabs = [
    { label: "Canevas", icon: "/assets/menus/canevas.png", path: "/caneva", colorIdle: "#c24c2c" },
    // { label: "Stream", icon: "/assets/menus/stream.png", path: "/stream", colorIdle: "#3b5d5e" },
    // { label: "Minds", icon: "/assets/menus/minds.png", path: "/minds", colorIdle: "#5c4b6e" },
    // { label: "Pulse", icon: "/assets/menus/pulse.png", path: "/pulse", colorIdle: "#6b4c4c" },
    // { label: "Orbit", icon: "/assets/menus/orbit.png", path: "/orbit", colorIdle: "#365a9b" },
  ];

  const dropdownMenuItems = [
    { icon: "/assets/icones/home.svg", label: "Home Page", link: "/HomePage" },
    { icon: "/assets/icones/profil.svg", label: "Mon profil", link: "/profil" },
    { icon: "/assets/icones/setting.svg", label: "Paramètres", link: "/settings" },
    { icon: "/assets/icones/grid.svg", label: "Account", link: "/account" },
    { icon: "/assets/icones/sliders.svg", label: "Library", link: "/Library" },
    { icon: "/assets/icones/log-out.svg", label: "Déconnexion", onClick: handleLogout },
  ];

  const handleTabClick = (index) => {
    setActiveIndex(index);
    navigate(navbarTabs[index].path);
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: `0 ${theme.spacing.lg}px`,
        height: "100%",
        backgroundColor: theme.colors.background.header,
        boxSizing: "border-box",
        backdropFilter: theme.effects.backdropBlur,
        boxShadow: "0 2px 6px rgba(0, 0, 0, 0.02)",
        borderColor: "#BFC7C7",
        borderBottomWidth: "thin",
        borderBottomStyle: "solid",
        borderTopWidth: "thin",
        borderTopStyle: "solid",
        borderTopColor: "#BFC7C7",
      }}
    >
      {/* Container 1: Logo + label */}
      <div style={{ display: "flex", alignItems: "center", gap: theme.spacing.xs, marginLeft: -10 }}>
        {logo?.src && <img src={logo.src} alt="logo" style={{ height: 36, width: 36 }} />}
        {logo?.label && (
          <span
            style={{
              fontFamily: theme.fonts.corelia,
              fontWeight: theme.fontWeights.corelia,
              fontSize: theme.fontSizes.md,
              color: theme.colors.text.corelia,
              letterSpacing: "1px",
            }}
          >
            {logo.label}
          </span>
        )}
      </div>

      {/* Container 2: TabsNav */}
      <div
        style={{
          flex: 1,
          display: "flex",
          justifyContent: "left",
          paddingLeft: 200,
          fontFamily: theme.fonts.corelia,
          fontSize: theme.fontSizes.md,
          fontWeight: theme.fontWeights.normal,
        }}
      >
        <TabsNavHorizontal labels={navbarTabs} activeIndex={activeIndex} onChange={handleTabClick} />
      </div>

      {/* Container 3: Toolbar */}
      <div style={{ display: "flex", alignItems: "center", gap: theme.spacing.lg }}>
        <DropdownMenuList
          icon="/assets/icones/home.svg"
          chevronIcon="/assets/icones/chevron-down.svg"
          label=""
          items={dropdownMenuItems}
          direction="bottom"
          offsetX="-40"
          iconSize={16}
          chevronSize={18}
        />

        <div onClick={handleLogout} title="Déconnexion" style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
          <img src="/assets/icones/log-out.svg" alt="Déconnexion" style={{ height: 16, width: 16 }} />
        </div>

        <Link to="/About" style={{ display: "flex", alignItems: "center" }}>
          <img src="/assets/icones/book-open.svg" alt="Présentation" style={{ height: 16, width: 16 }} />
        </Link>
      </div>
    </div>
  );
};

export default Navbar;